import { isMobile } from 'react-device-detect';
import { createState } from '../../lib/create-state';
import { meta } from './meta';
import {
    CurrencyType,
    fetchScreenConfig,
    ScreenConfigRequestError,
    ScreenConfigState,
    SiteDataType,
} from '../../lib/screen-config';
import { current } from './game';

export const DEFAULT_SCREEN_CONFIG_STATE: ScreenConfigState = {
    env: '',
    screenConfig: {
        site: {
            siteCode: '',
            siteId: 0,
            homeUrl: '',
            helpUrl: '',
            responsibleUrl: '',
            data: {} as SiteDataType,
        },
        display: {
            enableAutoBuyLossLimit: false,
            showTotalTickets: false,
            defaultCurrency: 'game',
            enableCurrencyToggle: false,
            enableFreeBuyConfirm: false,
            enableUnlimitedAutoBuy: true,
            enableMaxCardAutoBuy: true,
            autoBuyLossLimitAmount: 100.0,
            autoBuyGameLimit: 10,
        },
        room: {
            skin: '',
            announcer: '',
            caller: '',
            locale: '',
            localeId: 0,
            gameId: '',
        },
        casinoAssetsURL: '',
    },
    sideGames: [],
    language: '',
};

export const [screenConfig, resetScreenConfig] = createState<ScreenConfigState>(
    DEFAULT_SCREEN_CONFIG_STATE
);

export const getScreenConfig = async () => {
    meta.loaders.screenConfig.set(true);

    try {
        const searchParams = new URLSearchParams(window.location.search);

        if (isMobile) {
            searchParams.set('MOBILE', 'true');
        }

        const newConfig = await fetchScreenConfig();

        screenConfig.set(newConfig);

        meta.loaded.screenConfig.set(true);
    } catch (error) {
        meta.modals.msgCommon.set({
            name:
                error instanceof ScreenConfigRequestError &&
                error.status === 401
                    ? 'error.not.authenticated'
                    : 'error.general',
            isOpen: true,
            closeBehavior: 'close',
            hideCloseButton: true,
        });
    }

    meta.loaders.screenConfig.set(false);
};

export const toggleCurrency = () => {
    if (!screenConfig.screenConfig.display.enableCurrencyToggle.value) {
        return;
    }

    const currencyType =
        screenConfig.screenConfig.display.defaultCurrency.value;

    const [currency, newCurrencyType] =
        currencyType === 'game'
            ? [current.player_currency.value, 'player' as CurrencyType]
            : [current.game_currency.value, 'game' as CurrencyType];

    screenConfig.screenConfig.display.defaultCurrency.set(newCurrencyType);
    meta.currency.set(currency);
};
